import {
    SUCCESSION_DRAWER_OPEN,
    SUCCESSION_DRAWER_CLOSE,
    SUCCESSION_PROFILE_DRAWER_UPDATE
} from '../constants/successionDrawerConstants';

export const openSuccessionDrawer = (userName) => ({
    type: SUCCESSION_DRAWER_OPEN,
    userName
});

export const closeSuccessionDrawer = () => ({
    type: SUCCESSION_DRAWER_CLOSE
});

export const updateSelectedProfileDrawer = (selectedProfileDrawer) => ({
    type: SUCCESSION_PROFILE_DRAWER_UPDATE,
    selectedProfileDrawer
});